// @flow
import {
  SET_REPORT_PREVIEW,
  SET_REPORT_FULL
} from 'modules/external_tenant/api/action_types/OwnerReportActionTypes';
import Dispatcher from 'dispatcher';
import ApiClient from 'utils/ApiClient';

class OwnerReportActions {
  fetchReportPreview = (applicationId: string) => {
    return ApiClient.get({
      path: `/home_applications/${applicationId}/preview_report`
    }).then(response => {
      Dispatcher.dispatch({
        type: SET_REPORT_PREVIEW,
        payload: response.report
      });
    });
  };

  fetchReportFull = (userId: string, applicationId: string) => {
    return ApiClient.get({
      path: `/users/${userId}/home_applications/${applicationId}/report`
    }).then(response => {
      Dispatcher.dispatch({
        type: SET_REPORT_FULL,
        payload: response.report
      });
    });
  };
}

export default new OwnerReportActions();
